/**
 * URL courte de secours imprimée au verso d'une carte (`app.jeraisonne.fr/c/ABC234`),
 * pour qui ne peut pas scanner le QR. Résout le code puis remplace l'URL par
 * la page permanente `/card/{id}`. Publique, comme /card/$cardId.
 */

import { useEffect, useState } from 'react';
import { useNavigate, useParams } from '@tanstack/react-router';
import { normalizeCardShortCode } from '@jeraisonne/db/cards';
import { resolveCardShortCode } from '@/lib/cards/api';

export function CardShortCodePage() {
  const { code } = useParams({ strict: false }) as { code: string };
  const navigate = useNavigate();
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const normalized = normalizeCardShortCode(code);
    if (!normalized) {
      setNotFound(true);
      return;
    }
    let cancelled = false;
    resolveCardShortCode(normalized)
      .then((id) => {
        if (cancelled) return;
        if (id) {
          // Un défi peut aussi passer par le lien court : on garde `?defi=`.
          const defi = new URLSearchParams(window.location.search).get('defi');
          void navigate({
            to: '/card/$cardId',
            params: { cardId: id },
            search: defi ? { defi } : {},
            replace: true,
          });
        } else setNotFound(true);
      })
      .catch(() => {
        if (!cancelled) setNotFound(true);
      });
    return () => {
      cancelled = true;
    };
  }, [code, navigate]);

  return (
    <div className="flex min-h-dvh items-center justify-center px-4">
      <p role={notFound ? 'alert' : 'status'} className="text-ink-600 text-center text-sm">
        {notFound ? 'Aucune carte ne correspond à ce code.' : 'Ouverture de la carte…'}
      </p>
    </div>
  );
}
